'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const pathname = usePathname();

  const getDashboardLink = () => {
    if (pathname?.startsWith('/customer')) return '/customer/dashboard';
    if (pathname?.startsWith('/technician')) return '/technician/today';
    return '/dashboard';
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-8xl font-bold text-cyan-600 mb-2">404</div>
          <div className="flex justify-center mb-4">
            <div className="w-32 h-32 bg-cyan-100 rounded-full flex items-center justify-center">
              <Search className="h-16 w-16 text-cyan-600 animate-pulse" />
            </div>
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-3xl font-bold text-slate-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-slate-600 mb-8">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. 
          It might have been moved or doesn&apos;t exist.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Link href={getDashboardLink()} className="block">
            <Button className="w-full">
              <Home className="mr-2 h-4 w-4" />
              Go to Dashboard
            </Button>
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="w-full px-4 py-2 border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </button>
        </div>

        {/* Help Text */}
        <div className="mt-8 pt-8 border-t border-slate-200">
          <p className="text-sm text-slate-500">
            If you believe this is a mistake, please{' '}
            <Link href="/settings" className="text-cyan-600 hover:text-cyan-700 font-medium">
              contact support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
